module.exports = __webpack_public_path__ + "static/media/gb.d87f3776.svg";